import React, { useState, Fragment, useEffect } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Select from "react-select";
import AddSubOccupation from "./AddSubOccupation";
import { getAllSubOccupation } from "../../actions/shg";
import EditSubOccupation from "./EditSubOccupation";
import Spinner from "../layout/Spinner";
import Pagination from "../layout/Pagination";
import DeactiveSubOccupation from "./DeactiveSubOccupation";
const AllSubOccupation = ({
  auth: { isAuthenticated, user, users },
  shg: { activeInstitutions, allSubOccupation },
  getAllSubOccupation,
}) => {
  useEffect(() => {
    getAllSubOccupation();
  }, [getAllSubOccupation]);
  const [showAddSubOccupationModal, setShowAddSubOccupationModal] = useState(
    false
  );
  const handleAddSubOccupationModalClose = () =>
    setShowAddSubOccupationModal(false);
  const onClickHandler = () => {
    setShowAddSubOccupationModal(true);
  };

  const onAddSubOccupationModalChange = (e) => {
    if (e) {
      handleAddSubOccupationModalClose();
    }
  };
  const onUpdateModalChange = (e) => {
    if (e) {
      handleUpdateModalClose();
    }
  };

  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const handleUpdateModalClose = () => setShowUpdateModal(false);

  const [userData, setUserData] = useState(null);
  const onEdit = (allSubOccupation, idx) => {
    setShowUpdateModal(true);
    setUserData(allSubOccupation);
  };

  //pagination code
  const [currentData, setCurrentData] = useState(1);
  const [dataPerPage] = useState(10);
  //Get Current Data
  const indexOfLastData = currentData * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentDatas =
    allSubOccupation &&
    allSubOccupation.slice(indexOfFirstData, indexOfLastData);
  //change page
  const paginate = (nmbr) => {
    setCurrentData(nmbr);
  };
  //pagination code ends

  const allinstitution = [];
  // let activeInstitutionData = JSON.parse(
  //   localStorage.getItem("activeInstitutionData")
  // );
  activeInstitutions &&
    activeInstitutions.map((institution) =>
      allinstitution.push({
        institutionId: institution._id,
        label: institution.institutionName,
        value: institution.institutionName,
      })
    );

  const [institution, getinstitutionData] = useState();
  const [institutionId, setinstitutionId] = useState();
  const [institutionName, setinstitutionName] = useState();

  const onInstitutionChange = (e) => {
    var institutionId = "";
    var institutionName = "";
    getinstitutionData(e);
    institutionId = e.institutionId;
    institutionName = e.value;
    setinstitutionId(institutionId);
    setinstitutionName(institutionName);
    const changeData = {
      institutionIdVal: e.institutionId,
    };
    getAllSubOccupation(changeData);
  };

  const [showDeactiveModal, setShowDeactiveModal] = useState(false);
  const handleDeactiveModalClose = () => setShowDeactiveModal(false);

  const onDeactiveModalChange = (e) => {
    if (e) {
      handleDeactiveModalClose();
    }
  };
  const [userDataDeactive, setUserDataDeactive] = useState(null);
  const onUpdate = (allSubOccupation, idx) => {
    setShowDeactiveModal(true);
    setUserDataDeactive(allSubOccupation);
  };

  return !isAuthenticated || !user || !users ? (
    <Spinner />
  ) : (
    <Fragment>
      <div className="container container_align ">
        <section className="sub_reg">
          <div className="row col-lg-11 col-md-12 col-sm-12 col-12 no_padding">
            <div className="row col-lg-5 col-md-11 col-sm-10 col-10">
              <h5 className="heading_color">All Sub Occupation Details</h5>
              <div className="col-lg-5 col-md-11 col-sm-11 col-11">
                {user.userGroupName === "Super Admin" && (
                  <Select
                    name="institutionName"
                    options={allinstitution}
                    isSearchable={true}
                    value={institution}
                    placeholder="Institution"
                    onChange={(e) => onInstitutionChange(e)}
                    theme={(theme) => ({
                      ...theme,
                      height: 26,
                      minHeight: 26,
                      borderRadius: 1,
                      colors: {
                        ...theme.colors,
                        primary: "black",
                      },
                    })}
                  />
                )}
              </div>
            </div>
            {user.userGroupName !== "Super Admin" && (
              <div className="col-lg-7 col-md-1 col-sm-1 col-1 py-4">
                <img
                  className="img_icon_size log float-right"
                  onClick={() => onClickHandler()}
                  src={require("../../static/images/add-icon.png")}
                  alt="Add Sub Occupation"
                  title="Add Sub Occupation"
                />
              </div>
            )}
          </div>

          <div className="row">
            <div className="col-lg-11 col-md-12 col-sm-12 col-12 text-center py-2">
              <section className="body">
                <div className=" body-inner no-padding  table-responsive">
                  <table
                    className="table table-bordered table-striped table-hover"
                    id="datatable2"
                  >
                    <thead>
                      <tr>
                        <th>Sub Occupation</th>
                        <th>Occupation</th>
                        {user.userGroupName !== "Super Admin" && <th>Op</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {currentDatas &&
                        currentDatas.map((allSubOccupation, idx) => {
                          return (
                            <tr key={idx}>
                              {allSubOccupation.subOccupationStatus &&
                              allSubOccupation.subOccupationStatus ===
                                "Deactive" ? (
                                <td
                                  className=" secondlinebreak1"
                                  style={{ backgroundColor: "#dda6a6" }}
                                >
                                  {allSubOccupation.subOccupationName}
                                </td>
                              ) : (
                                <td className=" secondlinebreak1">
                                  {allSubOccupation.subOccupationName}
                                </td>
                              )}

                              <td>
                                {allSubOccupation &&
                                  allSubOccupation.output[0] &&
                                  allSubOccupation.output[0].occcupationName}
                              </td>
                              {allSubOccupation.subOccupationStatus &&
                              allSubOccupation.subOccupationStatus !==
                                "Deactive"
                                ? user.userGroupName !== "Super Admin" && (
                                    <td>
                                      <img
                                        className="img_icon_size log"
                                        onClick={() =>
                                          onUpdate(allSubOccupation, idx)
                                        }
                                        src={require("../../static/images/delete.png")}
                                        alt="Deactivate Sub Occupation"
                                        title="Deactivate Sub Occupation"
                                      />{" "}
                                      &nbsp;
                                      <img
                                        className="img_icon_size log"
                                        onClick={() =>
                                          onEdit(allSubOccupation, idx)
                                        }
                                        src={require("../../static/images/edit_icon.png")}
                                        alt="Edit Sub Occupation"
                                        title="Edit Sub Occupation"
                                      />
                                    </td>
                                  )
                                : user.userGroupName !== "Super Admin" && (
                                    <td>Deactivated</td>
                                  )}
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12 no_padding">
                    {allSubOccupation && allSubOccupation.length !== 0 ? (
                      <Pagination
                        dataPerPage={dataPerPage}
                        totalData={allSubOccupation.length}
                        paginate={paginate}
                        currentPage={currentData}
                      />
                    ) : (
                      <Fragment />
                    )}
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12 align_right">
                    <label>
                      No. of Sub Occupations : {allSubOccupation.length}
                    </label>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
        <Modal
          show={showAddSubOccupationModal}
          backdrop="static"
          keyboard={false}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header>
            <div className="col-lg-10">
              <h3 className="modal-title text-center">Add Sub Occupation</h3>
            </div>
            <div className="col-lg-2">
              <button
                onClick={handleAddSubOccupationModalClose}
                className="close"
              >
                <img
                  src={require("../../static/images/close.png")}
                  alt="X"
                  style={{ height: "20px", width: "20px" }}
                />
              </button>
            </div>
          </Modal.Header>
          <Modal.Body>
            <AddSubOccupation
              onAddSubOccupationModalChange={onAddSubOccupationModalChange}
              setShowAddSubOccupationModal={setShowAddSubOccupationModal}
            />
          </Modal.Body>
        </Modal>
        <Modal
          show={showUpdateModal}
          backdrop="static"
          keyboard={false}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header>
            <div className="col-lg-10">
              <h3 className="modal-title text-center">Edit Sub Occupation</h3>
            </div>
            <div className="col-lg-2">
              <button onClick={handleUpdateModalClose} className="close">
                <img
                  src={require("../../static/images/close.png")}
                  alt="X"
                  style={{ height: "20px", width: "20px" }}
                />
              </button>
            </div>
          </Modal.Header>
          <Modal.Body>
            <EditSubOccupation
              allSubOccupation={userData}
              onUpdateModalChange={onUpdateModalChange}
            />
          </Modal.Body>
        </Modal>

        <Modal
          show={showDeactiveModal}
          backdrop="static"
          keyboard={false}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header>
            <div className="col-lg-10">
              <h3 className="modal-title text-center">
                Deactivate Sub Occupation
              </h3>
            </div>
            <div className="col-lg-2">
              <button onClick={handleDeactiveModalClose} className="close">
                <img
                  src={require("../../static/images/close.png")}
                  alt="X"
                  style={{ height: "20px", width: "20px" }}
                />
              </button>
            </div>
          </Modal.Header>
          <Modal.Body>
            <DeactiveSubOccupation
              allSubOccupation={userDataDeactive}
              onDeactiveModalChange={onDeactiveModalChange}
            />
          </Modal.Body>
        </Modal>
      </div>
    </Fragment>
  );
};

AllSubOccupation.propTypes = {
  auth: PropTypes.object.isRequired,
  shg: PropTypes.object.isRequired,
  getAllSubOccupation: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  shg: state.shg,
});

export default connect(mapStateToProps, {
  getAllSubOccupation,
})(AllSubOccupation);
